import Game from "../../../Game.js";
import Control from "../../controllers/Control.js";
import ItemSlot from "../../itemSlot/ItemSlot.js";

export default class ChestContent {
	constructor(callback,chestId) {
		this.callback = callback;
		this.chestId = chestId;
		ChestContent.IDS = 0;
		this.typeContainer = "chestcontent";
		
	}

	init() {
		this.mc = jQuery("#template-chest-content").clone();
		this.mc.attr("id", "checon" + ChestContent.ENUM++);
		this.build();
		jQuery(".js-take-all", this.mc).on("click", this.onTakeAll.bind(this))
		jQuery(window).off("keydown.loot");
		setTimeout(this.setKey.bind(this), 50);
		

	}
	setKey() {
		jQuery(window).off("keydown.loot");
		jQuery(window).on("keydown.loot", this.userPressedKey.bind(this));
	}

	getClip() {
		return this.mc;
	}

	build() {
		this.slots = new Array();
		for (let row = 0; row < ChestContent.SLOTS / ChestContent.PER_LINES; row++) {
			//this.slots.push(new Array());
			for (let col = 0; col < ChestContent.PER_LINES; col++) {
				let id = "che" + ChestContent.IDS;
				ChestContent.IDS++;
				let itemSlot = new ItemSlot(id, this.createSlot(id, row, col), null, null,this.itemSlotEventsHandler.bind(this))
				//this.slots.push({ id: "" + id, slot: this.createSlot(id, row, col), item: null });
				this.slots.push(itemSlot);
			}
		}
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	onTakeAll(e) {
		jQuery(window).off("keydown.loot");
		jQuery(".js-take-all", this.mc).off("click")
		this.dispatch({ type: ChestContent.EVENT_TAKE_ALL, data: this });

	}

	userPressedKey(e) {
		if ((e.keyCode === Control.FIRE) || (e.keyCode === Control.FIRE_ALT)) {
			this.onTakeAll(e);
		}
	}



	itemSlotEventsHandler(e) {
		e.data.from = this;
		this.dispatch(e);
	}


	createSlot(id, row, col) {
		let slot = jQuery("#template-slot-inventory").clone();
		slot.attr("id", "sloche" + ChestContent.ENUM++);
		slot.attr("data-ref", id);
		jQuery(".js-slots", this.mc).append(slot);
		jQuery(".js-empty", slot).css("background-image", "url('" + "./assets/ui/empty_slot.png" + "')");
		jQuery(".js-over", slot).css("background-image", "url('" + "./assets/ui/highlight_slot.png" + "')");
		jQuery(".js-filled", slot).css({ width: Game.TILE_WIDTH, height: Game.TILE_HEIGHT, left: (ChestContent.DIM_SLOT - Game.TILE_WIDTH) / 2, top: (ChestContent.DIM_SLOT - Game.TILE_HEIGHT) / 2 });
		slot.css({
			top: row * ChestContent.DIM_SLOT + ChestContent.SPAN_Y * row,
			left: col * ChestContent.DIM_SLOT + ChestContent.SPAN_X * col
		})

		return slot;
	}

	destroy() {
		//console.log("AAA")
		jQuery(window).off("keydown.loot");
	}

	addItem(item, containerPos) {
		//console.log(item)
		let retItem = null;
		let itemSlot;
		if (containerPos === -1) {
			// Primo libero
			for (let x = 0; x < this.slots.length; x++) {
				itemSlot = this.slots[x];
				if (!itemSlot.item) {
					break;
				}
			}
		} else {
			// posizione esatta
			for (let x = 0; x < this.slots.length; x++) {
				itemSlot = this.slots[x];
				if (itemSlot.id === containerPos) {
					break;
				}
			}
		}

		if (itemSlot) {
			if (itemSlot.hasItem()) {
				retItem = itemSlot.getItem();
			}
			itemSlot.setItem(item);
		}
		return retItem;
	}

	removeItem(item) {
		/*if (!item) {
			return;
		}*/
		for (let x = 0; x < this.slots.length; x++) {
			let itemSlot = this.slots[x];
			if (itemSlot.id === item.containerPos) {
				itemSlot.removeItem(item);
				break;
			}
		}
	}


	getItemsSlots() {
		return this.slots;
	}




}
ChestContent.IDS = 0;
ChestContent.ENUM = 0;
ChestContent.SLOTS = 5;
ChestContent.PER_LINES = 5;
ChestContent.DIM_SLOT = 36;
ChestContent.SPAN_X = 10;
ChestContent.SPAN_Y = 4;

ChestContent.EVENT_TAKE_ALL = "eventTakeAll"
